import * as types from './types'
import router from '@/router'
import axios from 'axios'

const actions = {
  INIT ({ commit, firebase }) {
    return new Promise(resolve => {
      firebase.auth().onAuthStateChanged(async user => {
        let abilities = []

        if (user) {
          const result = await firebase.auth().currentUser.getIdTokenResult()
          abilities = result.claims.abilities
          commit('currentCompanyId', result.claims.currentCompany)
          commit('setAbilities', abilities)
        } else {
          commit('currentCompanyId', null)
          commit('setAbilities', [])
        }

        commit('setUser', user || {})
        commit('setIsAuthenticated', !!user)
        commit('setLoading', false)

        !user && router.push({ name: 'Login' })
        resolve(abilities)
      })
    })
  },
  [types.SIGN_IN] ({ commit, firebase }, { email, password }) {
    let auth = firebase.auth()
    auth
      .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      .then(() => {
        commit('setLoading', true)
        auth
          .signInWithEmailAndPassword(email, password)
          .then(user => {
            commit('setLoading', false)
            commit('setUser', user)
            commit('setIsAuthenticated', true)
            router.push('/')
          }).catch(error => {
            console.log('error', error)
            commit('setUser', {})
            commit('setIsAuthenticated', false)
            commit('setLoading', false)
          })
      })
  },
  [types.SIGN_OUT] ({ commit, firebase }) {
    firebase
      .auth()
      .signOut()
      .then(() => {
        commit('setUser', null)
        commit('setIsAuthenticated', false)
        router.push('/login')
      })
      .catch(() => {
        commit('setUser', null)
        commit('setIsAuthenticated', false)
        router.push('/')
      })
  },
  [types.GET_SETTINGS] ({ commit }, settings) {
    commit(types.SET_SETTINGS, settings)
  },
  [types.SET_CURRENT_COMPANY] ({ commit, firebase }, companyId) {
    return firebase.auth().currentUser.getIdTokenResult().then(result => {
      axios.defaults.headers.common['Authorization'] = `Bearer ${result.token}`

      return axios
        .post('/api/setCurrentCompany', { companyId })
        .then(({ status }) => {
          if (status === 200) {
            commit('currentCompanyId', companyId)
            firebase.auth().currentUser.getIdTokenResult(true)
            return companyId
          }
        })
    })
  },
  [types.PROCESS_FILE] ({ commit, firebase }, companyId) {
    return firebase.auth().currentUser.getIdTokenResult().then(result => {
      axios.defaults.headers.common['Authorization'] = `Bearer ${result.token}`

      return axios
        .post('/api/processFile')
        .then(({ status }) => {
          if (status === 200) {
            // commit('currentCompanyId', companyId)
            // return companyId
          }
        })
    })
  },
  getLoading ({ commit, state }) {
    commit('setLoading', state.isLoading)
  }
}

export default actions
